import React from 'react'
import '../styles/Answer.css' // Import the CSS file

export default function Answer(props) {
  const correct = props.selected == props.answer;
  
  const getOptionClass = (id) => {
    if (props.selected == id && props.answer == id) {
      return "option-item correct"; // User selected correct answer
    }
    if (props.selected == id && props.answer != id) {
      return "option-item wrong"; // User selected wrong answer
    }
    if (props.answer == id) {
      return "option-item correct"; // Correct answer (not selected by user)
    }
    return "option-item"; // Default option
  }

  const getOptionIndicator = (id) => {
    if (props.answer == id) {
      return <span className="option-indicator correct-indicator">✓ Correct</span>;
    }
    if (props.selected == id && props.answer != id) {
      return <span className="option-indicator wrong-indicator">✗ Wrong</span>;
    }
    return null;
  }

  return (
    <div className="answer-card">
      <div className="answer-header">
        <span className="question-number">Question {props.id + 1}</span>
        {correct ? (
          <span className="result-badge correct-badge">✓ Correct</span>
        ) : (
          <span className="result-badge wrong-badge">✗ Incorrect</span>
        )}
      </div>
      
      <div className="answer-body">
        <h5 className="question-text">{props.question.question}</h5>
        
        <div className="options-container">
          <div className={getOptionClass("1")}>
            <span className="option-label">A.</span>
            <span className="option-text">{props.question.options[0]}</span>
            {getOptionIndicator("1")}
          </div>
          
          <div className={getOptionClass("2")}>
            <span className="option-label">B.</span>
            <span className="option-text">{props.question.options[1]}</span>
            {getOptionIndicator("2")}
          </div>
          
          <div className={getOptionClass("3")}>
            <span className="option-label">C.</span>
            <span className="option-text">{props.question.options[2]}</span>
            {getOptionIndicator("3")}
          </div>
          
          <div className={getOptionClass("4")}>
            <span className="option-label">D.</span>
            <span className="option-text">{props.question.options[3]}</span>
            {getOptionIndicator("4")}
          </div>
        </div>
      </div>
      
      {!correct && props.question.description && (
        <div className="description-container">
          <div className="description-header">
            <span className="description-icon">💡</span>
            <span className="description-title">Explanation</span>
          </div>
          <div className="description-text">
            {props.question.description}
          </div>
        </div>
      )}
    </div>
  )
}